import SEOHead from "@/components/SEOHead";
import Navbar from "@/components/Navbar";
import ScrollProgressBar from "@/components/ScrollProgressBar";
import HeroSection from "@/components/HeroSection";
import ServicesSection from "@/components/ServicesSection";
import SaasVsCustomSection from "@/components/SaasVsCustomSection";
import PlainPathSection from "@/components/PlainPathSection";
import WhyDevCoreSection from "@/components/WhyDevCoreSection";
import ShowcaseSection from "@/components/ShowcaseSection";
import AISection from "@/components/AISection";
import AIEmbedSection from "@/components/AIEmbedSection";
import ProcessSection from "@/components/ProcessSection";
import AboutSection from "@/components/AboutSection";
import TestimonialsSection from "@/components/TestimonialsSection";
import TechStackSection from "@/components/TechStackSection";
import IntegrationsSection from "@/components/IntegrationsSection";
import CTASection from "@/components/CTASection";
import BlueprintGenerator from "@/components/BlueprintGenerator";
import FAQSection, { faqs } from "@/components/FAQSection";
import MobileStickyCTA from "@/components/MobileStickyCTA";


import FiberStrands from "@/components/FiberStrands";
import Footer from "@/components/Footer";
import { useFaqs, useSeoDefaults } from "@/hooks/usePublicContent";
import { useLocale } from "@/i18n/LocaleProvider";

import { useTranslation } from "react-i18next";

const Index = () => {
  const { lang } = useLocale();
  const { t } = useTranslation();
  const { data: liveFaqs } = useFaqs(lang);
  const { data: seo } = useSeoDefaults(lang);

  // Per-language admin-editable SEO copy wins; the i18n bundle is the fallback
  // so every locale stays self-descriptive even before defaults are saved.
  const seoTitle = seo?.title || t("seoHome.title");
  const seoDescription = seo?.description || t("seoHome.description");



  const faqSource =
    liveFaqs && liveFaqs.length > 0
      ? liveFaqs.map((f) => ({ question: f.question, answer: f.answer }))
      : faqs;


  const faqJsonLd = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqSource.map((faq) => ({
      "@type": "Question",
      name: faq.question,
      acceptedAnswer: {
        "@type": "Answer",
        text: faq.answer,
      },
    })),
  };

  return (
    <div className="min-h-screen relative">
      <SEOHead
        title={seoTitle}
        description={seoDescription}
        canonical="https://devcore.systems/"
        ogImage={seo?.ogImage || undefined}
        jsonLd={faqJsonLd}
      />


      <ScrollProgressBar />
      <Navbar />
      <FiberStrands />
      <main className="relative z-[1] fiber-host">
        <HeroSection />
        <SaasVsCustomSection />
        <ServicesSection />

        <PlainPathSection />
        <ShowcaseSection />
        <TestimonialsSection />
        <WhyDevCoreSection />
        <ProcessSection />
        <AISection />
        <AIEmbedSection />
        <BlueprintGenerator redirectOnResult />
        <AboutSection />
        <TechStackSection />
        <IntegrationsSection />
        <FAQSection />
        <CTASection />
      </main>

      <Footer />
      <MobileStickyCTA />

    </div>
  );
};

export default Index;

